<template>
    <div class="cardEquipe">
        <div class="image" :style="{ 'background-image': 'url(' + imgagemPadrao + ')' }"></div>
        <div class="info">
            <p>{{ nome }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'nome',
        'imagem'
    ],
    data () {
        return {}
    },
    created: function () {
        if (this.imagem) {
            this.imgagemPadrao = this.imagem
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../assets/sass/_mixin"

    .cardEquipe
        width: 200px
        background-color: #ffffff
        background-size: cover
        background-position: center
        z-index: 2
        margin: 10px
        position: relative
        cursor: pointer
        @include transition(box-shadow .15s ease-in-out, transform .15s ease-in-out)
        @include device(mobile)
            &
                min-width: 200px
        &:hover
            // box-shadow: 0 2px 10px -2px rgba(0,0,0,.2)
            box-shadow: 3px 3px 8px -4px #00000073
            transform: scale(1.01)

        .image
            display: flex
            justify-content: flex-end
            align-items: flex-start
            height: 300px
            // border-radius: 5px
            background-size: cover
            background-repeat: no-repeat
            background-position: top
            // box-shadow: inset 0px 0px 150px 0px #00000052
            // -moz-box-shadow: inset 0px 0px 150px 0px #00000052
            // -webkit-box-shadow: inset 0px 0px 150px 0px #00000052

        .info
            height: 45px
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            padding: 0 12px
            position: absolute
            bottom: 15px
            left: 2px
            right: 2px
            background-color: white
            p
                text-align: center
                line-height: 1
                margin: 0
                font-size: 18px
</style>
